import React from "react";
// import styles from "./TextareaInput.module.css";
import CommonStyles from "../InputFieldsController/InputFieldsController.module.css";
import { Form } from "react-bootstrap";
import {
  FieldProps,
  getFieldContainerStyle,
} from "../InputFieldsController/InputFieldsController.utils";
import LabeledInputWrapper from "../InputFieldsController/LabeledInputWrapper";

interface TextareaInputProps {
  field: FieldProps;
  handleChange: (fieldId: string, event: any) => void;
  handleBlur: (fieldId: string) => void;
  handleSelect: (fieldId: string) => void;
}

/**
 * TextareaInput renders a multi-line text input field.
 * It supports dynamic layout, validation, required indicator, and examples.
 *
 * @component
 * @param {Object} props - Component props
 * @param {FieldProps} props.field - Field metadata and configuration
 * @param {(fieldId: string, event: any) => void} props.handleChange - Function to update field value
 * @returns {JSX.Element | null} The rendered textarea input or null if hidden
 */
const TextareaInput: React.FC<TextareaInputProps> = ({
  field,
  handleChange,
  handleBlur,
  handleSelect,
}) => {
  const {
    id,
    placeholder,
    value,
    example,
    show = true,
    disabled,
    isValid = true,
    error,
    selected
  } = field;

  if (!show) return null;

  const containerStyle = getFieldContainerStyle(field);

  return (
    <div style={containerStyle}>
      <LabeledInputWrapper field={field}>
        <Form.Control
          as="textarea"
          id={id}
          rows={4}
          value={value ?? ""}
          placeholder={placeholder}
          disabled={disabled}
          onChange={(e) => handleChange(id, e)}
          onBlur={() => handleBlur(id)}
          onClick={() => handleSelect(id)}
          isInvalid={!isValid}
          className={`${CommonStyles.customInput} ${
            selected ? CommonStyles.selectedField : ""
          }`}
        />
        {!isValid && error && (
          <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
        )}
      </LabeledInputWrapper>

      {example && <small className="text-muted">Example: {example}</small>}
    </div>
  );
};

export default TextareaInput;
